import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import RequirePartnerAccess from '../containers/RequirePartnerAccess';
import NotAuthorized from '../components/NotAuthorized';

function PartnerRoute({ children }) {
    const { partnerId } = useParams();

    return (
        <RequirePartnerAccess
            partnerId={partnerId}
            fallback={<NotAuthorized />}
        >
            <>{children}</>
        </RequirePartnerAccess>
    );
}

export default observer(PartnerRoute);
